"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var validationUtils_1 = require("./validationUtils");
var useForm = function (onSubmit, validators, defaultValues) {
    var _a = (0, react_1.useState)(defaultValues), formValues = _a[0], setValues = _a[1];
    var _b = (0, react_1.useState)({}), validationErrors = _b[0], setValidationErrors = _b[1];
    var _c = (0, react_1.useState)(false), hasErrors = _c[0], setHasErrors = _c[1];
    var _d = (0, react_1.useState)(false), shouldValidate = _d[0], setShouldValidate = _d[1];
    var _e = (0, react_1.useState)(false), hasUnsavedChanges = _e[0], setHasUnsavedChanges = _e[1];
    (0, react_1.useEffect)(function () {
        setHasErrors((0, validationUtils_1.checkHasErrors)(validationErrors));
    }, [validationErrors]);
    var resetForm = function () {
        setHasUnsavedChanges(false);
        setValues(defaultValues);
        setValidationErrors({});
        setShouldValidate(false);
    };
    var handleSubmit = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        var currentErrors = (0, validationUtils_1.validateAllFields)(formValues, validators);
        if (!(0, validationUtils_1.checkHasErrors)(currentErrors)) {
            onSubmit({ formValues: formValues, resetFormCallback: resetForm, setAllChangesSaved: function () { return setHasUnsavedChanges(false); } });
        }
        setValidationErrors(currentErrors);
        setShouldValidate(true);
    };
    var handleValueChange = function (name, value) {
        var _a;
        var _b;
        setValues(function (prevValues) {
            var _a;
            return (__assign(__assign({}, prevValues), (_a = {}, _a[name] = value, _a)));
        });
        setHasUnsavedChanges(true);
        if (shouldValidate) {
            var err_1 = (0, validationUtils_1.validateField)(__assign(__assign({}, formValues), (_a = {}, _a[name] = value, _a)), (_b = validators[name]) !== null && _b !== void 0 ? _b : null, name);
            setValidationErrors(function (prevErrors) {
                var _a;
                return (__assign(__assign({}, prevErrors), (_a = {}, _a[name] = err_1, _a)));
            });
        }
    };
    var handleChange = function (name) { return function (event) {
        handleValueChange(name, event.target.value);
    }; };
    var handleCheckedChange = function (name) { return function (event) {
        handleValueChange(name, event.target.checked);
    }; };
    return {
        handleValueChange: handleValueChange,
        handleChange: handleChange,
        handleCheckedChange: handleCheckedChange,
        handleSubmit: handleSubmit,
        formValues: formValues,
        validationErrors: validationErrors,
        hasErrors: hasErrors,
        hasUnsavedChanges: hasUnsavedChanges,
        resetForm: resetForm,
    };
};
exports.default = useForm;
